import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Switch } from 'react-router-dom';
import { Route, routerConfig } from '@/app/routing/index';
import AuthProvider from '@/app/providers/AuthProvider';
import DecedentProvider from '@/app/providers/DecedentProvider';
import { queryClient } from '@/app/query-client';
import NotificationProvider from '@/common/containers/NotificationProvider/index';
import { useLocale } from '@/common/hooks/index';
import enUS from 'date-fns/locale/en-US';
import frCA from 'date-fns/locale/fr-CA';
import { QueryClientProvider } from '@tanstack/react-query';
import muiTheme from '@/common/styles/mui-theme';
import PageMetadata from '@/app/PageMetadata';
import { FallbackRedirect } from '@/app/routing/Route';

function App() {
  const { isFr } = useLocale();

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        locale={isFr ? frCA : enUS}
        localeText={{
          fieldMonthPlaceholder: ({ contentType }) =>
            contentType === 'letter' ? 'MMM' : 'MM',
        }}
      >
        <QueryClientProvider client={queryClient}>
          <PageMetadata />
          <AuthProvider>
            <DecedentProvider>
              <NotificationProvider />
              <Switch>
                {routerConfig.map((route) => (
                  <Route key={route.path} {...route} />
                ))}
                <FallbackRedirect />
              </Switch>
            </DecedentProvider>
          </AuthProvider>
        </QueryClientProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
